var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000001_1324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4859 7.05194C14.1706 6.34742 14.1728 5.20258 13.4903 4.49806C13.2278 4.2271 12.8865 4.04645 12.519 3.98774L9.80214 3.55419L8.56401 0.998065C8.2687 0.386129 7.66276 0 6.99995 0H6.94526C6.30213 0.0203226 5.72245 0.404194 5.4337 0.998065L4.19776 3.55194L1.48088 3.98774C0.527134 4.14129 -0.126928 5.06484 0.021822 6.04936C0.078697 6.42871 0.251509 6.77871 0.516197 7.05194L2.46745 9.06387C2.46745 9.06387 2.46963 9.07742 2.46745 9.08419L2.02995 11.9045C1.87463 12.889 2.52432 13.8171 3.47807 13.9774C3.84995 14.0384 4.23057 13.9774 4.56307 13.7968L7.00213 12.4871L9.43682 13.7968C10.2943 14.2552 11.3509 13.9097 11.7949 13.0245C11.9678 12.679 12.029 12.2884 11.9699 11.9045L11.5324 9.08419C11.5324 9.08419 11.5303 9.07064 11.5324 9.06387L13.4881 7.05194H13.4859ZM10.2987 7.78581C9.89839 8.20129 9.71245 8.78839 9.80214 9.36645L10.2396 12.189L7.80057 10.8839C7.29745 10.6174 6.70245 10.6174 6.19932 10.8839L3.75588 12.1935L4.19338 9.37097C4.28307 8.7929 4.09713 8.20581 3.69682 7.79032L1.74995 5.77387L4.46682 5.33806C5.02682 5.24774 5.50807 4.88419 5.76182 4.36032L6.99995 1.80645L8.23807 4.36032C8.49182 4.88419 8.97307 5.24774 9.53307 5.33806L12.2499 5.77387L10.2987 7.78581Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000001_1324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusBalance);
export default __webpack_public_path__ + "static/media/bonus-balance.21742aaeaa30d79602f3d2c89f72a972.svg";
export { ForwardRef as ReactComponent };